import type { NotificationFormType } from '@/notificationForms'
import type { NotificationFormValues } from './types'

import { produce } from 'immer'

const formFields = {
  includeMessageUnsubscriptionInstructionsEmail: {
    visible: true,
    disabled: false,
  },
  includeMessageUnsubscriptionInstructionsPhone: {
    visible: true,
    disabled: false,
  },
  windowOfCommitmentToleranceMins: {
    visible: false,
    disabled: false,
  },
  windowOfCommitmentSnapToMins: {
    visible: false,
    disabled: false,
  },
  includeMessageTrackingLink: {
    visible: true,
    disabled: false,
  },
  alwaysNotifyAfterCutoff: {
    visible: false,
    disabled: false,
  },
  notificationCutoffMins: {
    disabled: true,
    visible: false,
  },
  proximityThresholdMins: {
    visible: false,
    disabled: false,
  },
  templateDefaultLimits: {
    visible: false,
    disabled: false,
  },
  templateCustomLimits: {
    visible: false,
    disabled: false,
  },
  backupSubjectCustom: {
    visible: false,
    disabled: false,
  },
  backupNotification: {
    visible: false,
    disabled: false,
  },
  notificationWay: {
    visible: true,
    disabled: false,
  },
  templatePreview: {
    visible: false,
    disabled: false,
  },
  templateDefault: {
    visible: false,
    disabled: false,
  },
  subjectDefault: {
    visible: false,
    disabled: false,
  },
  templateCustom: {
    visible: true,
    disabled: false,
  },
  toleranceMins: {
    visible: false,
    disabled: false,
  },
  subjectCustom: {
    visible: true,
    disabled: false,
  },
  enabled: {
    visible: true,
    disabled: false,
  },
}

/**
 * This method changes visibility/mandatory state of the fields based on the initial values
 * NOTE: We're setting up mandatory state before the initialization because, otherwise, the form will change his state to `indeterminate`
 */
export function getFormFields(values: NotificationFormValues, notification: NotificationFormType) {
  if (!values) return formFields

  return produce(formFields, draft => {
    // Set notificationCutoffMins for forms that requires it
    const formsWithNotificationTime = ['today', 'tomorrow', 'twoDays']
    if (formsWithNotificationTime.includes(notification)) {
      draft.notificationCutoffMins.disabled = false
      draft.notificationCutoffMins.visible = true
    }

    //Set toleranceMins for forms that requires it
    const formsWithToleranceMins = ['early', 'delayed']
    if (formsWithToleranceMins.includes(notification)) {
      draft.toleranceMins.visible = true
    }

    //Set proximityThresholdMins for forms that requires it
    const formsWithProximityThresholdMins = ['almostThere']
    if (formsWithProximityThresholdMins.includes(notification)) {
      draft.proximityThresholdMins.visible = true
    }

    if (values['notificationWay'] === 'PHONE') {
      // Changes based on the Notification Type
      // Disable subjectCustom field if the notification is an SMS
      draft.backupNotification.visible = true
      draft.subjectCustom.visible = false

      // Enable backupSubjectCustom field if the backupNotification is active
      if (values['backupNotification']) {
        draft.backupSubjectCustom.visible = true
      }
    }

    // // If the hotword @@ETARange@@ is present in templateCustom's value
    // // the windowOfCommitmentToleranceMins will be required
    if (values['templateCustom']?.indexOf('@@ETARange@@') !== -1) {
      draft.windowOfCommitmentToleranceMins.visible = true
    }
  })
}
